import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { isLegacyLoginEnabled } from '../../../environments/legacy-login';
import { AUTH_PATHS } from './auth';

@Injectable({
  providedIn: 'root',
})
export class LegacyLoginGuard {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (isLegacyLoginEnabled()) {
      return true;
    }

    return this.router.parseUrl('/' + AUTH_PATHS.login);
  }
}
